import React from 'react';
import { motion } from 'framer-motion';
import { Box, Container, Typography, Grid, Card, CardContent, Chip } from '@mui/material';
import {
  Calculate as Calculator,
  Description as FileText,
  Business as Building,
  Home as HomeIcon,
  Work as Briefcase
} from '@mui/icons-material';

export default function Services() {
  const services = [
    {
      icon: <FileText sx={{ fontSize: 32 }} />,
      title: "GST Registration & Filing",
      description: "Complete GST registration, return filing and compliance support for your business.",
      keywords: "GST Registration Rajkot, GST Filing",
    },
    {
      icon: <FileText sx={{ fontSize: 32 }} />,
      title: "Income Tax Services",
      description: "Expert Income Tax filing, TDS Returns, Tax Planning and Assessment support.",
      keywords: "Income Tax Filing Rajkot, Tax Returns",
    },
    {
      icon: <Building sx={{ fontSize: 32 }} />,
      title: "Business Registration",
      description: "Partnership Firm, Limited Liability Partnership and All business registrations.",
      keywords: "Business Registration Rajkot, Company Formation",
    },
    {
      icon: <Calculator sx={{ fontSize: 32 }} />,
      title: "Accounting & Bookkeeping",
      description: "Professional Accounting Services, Bookkeeping and Financial Statements.",
      keywords: "CA Services Rajkot, Accounting Services",
    },
    {
      icon: <Briefcase sx={{ fontSize: 32 }} />,
      title: "Business Loan",
      description: "All type of Business Loan Assistance like Machinery Loan, Cash Credit etc. with competitive interest rates and quick processing.",
      keywords: "Business Loan Rajkot",
    },
    {
      icon: <HomeIcon sx={{ fontSize: 32 }} />,
      title: "Home Loan",
      description: "Home loan solutions with best interest rates and flexible EMI options.",
      keywords: "Home Loan Rajkot",
      badge: "Coming Soon",
    },
  ];

  return (
    <Box component="section" id="services" sx={{ py: { xs: 10, md: 12 }, bgcolor: 'grey.50' }}>
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <Box sx={{ textAlign: 'center', mb: 8, mt: 1 }}>
            <Chip
              label="Our Services"
              sx={{
                mb: 2,
                bgcolor: 'rgba(30, 91, 92, 0.1)',
                color: 'rgba(30, 91, 92, 1)',
                fontWeight: 500
              }}
            />
            <Typography
              variant="h3"
              component="h2"
              sx={{ fontWeight: 'bold', mb: 2, fontSize: { xs: '2rem', md: '2.5rem' } }}
            >
              Comprehensive Taxation & Loan Services
            </Typography>
            <Typography
              variant="body1"
              sx={{ color: 'text.secondary', maxWidth: '32rem', mx: 'auto' }}
            >
              From Firm registration to Loan assistance, we provide complete
              financial solutions for businesses and individuals.
            </Typography>
          </Box>
        </motion.div>

        <Grid container spacing={3}>
          {services.map((service, index) => (
            <Grid item xs={12} md={6} lg={4} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                style={{ height: '100%' }}
              >
                <Card
                  sx={{
                    height: '100%',
                    transition: 'box-shadow 0.3s',
                    '&:hover': { boxShadow: 4 },
                    borderTop: '4px solid rgba(30, 91, 92, 1)'
                  }}
                >
                  <CardContent sx={{ p: 3 }}>
                    <Box
                      sx={{
                        width: 56,
                        height: 56,
                        borderRadius: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 2,
                        bgcolor: 'rgba(30, 91, 92, 0.1)',
                        color: 'rgba(30, 91, 92, 1)'
                      }}
                    >
                      {service.icon}
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                      <Typography variant="h6" component="h3" sx={{ fontWeight: 'bold' }}>
                        {service.title}
                      </Typography>
                      {service.badge && (
                        <Chip
                          label={service.badge}
                          size="small"
                          variant="outlined"
                          sx={{ fontSize: '0.75rem' }}
                        />
                      )}
                    </Box>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                      {service.description}
                    </Typography>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}